module.exports = __webpack_public_path__ + "files/fa44c89ddfe141733a9b014159b16a6e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/icons/excel.png
 ** module id = 378
 ** module chunks = 0
 **/